<template>
  <a-select
      show-search
      placeholder="请选择员工"
      option-filter-prop="children"
      style="width: 155px"
      :filter-option="false"
      :getPopupContainer="trigger => trigger.parentNode"
      @popupScroll="goodsScroll"
      @search="fetchStaff"
      @change="chooseOption"
      :value="currentValue.label?currentValue:undefined"
      label-in-value>
    <a-select-option v-for="(item,index) in staffList" :key="index" :value="item.id">
      {{item.name}}
    </a-select-option>
  </a-select>
</template>

<script>
export default {
  name: "staffSelector",
  props:{
   currentValue:{
      type:Object,
    }
  },
  data(){
    return{
      staffList: [],
      queryParam:{
        current:1,
        size:20,
        name:'',
      },
      selectOption:'',
      text:'',
    }
  },
  created() {
    this.getStaffDropDownList(this.queryParam);
  },
  methods:{
    chooseOption(value){
      const selectKey = value.key;
      const selectOption = this.staffList.filter(e=>e.id===selectKey)[0];
      this.$emit('staffSelectChange',value);
      this.$emit('staffCurrentSelect',selectOption);

    },
    fetchStaff(value){
      const params = {
        current:1,
        size:this.queryParam.size,
        name:value,
      }
      this.getStaffDropDownList(params);
    },
    goodsScroll(e){
      const { target } = e;
      if(target.scrollTop+target.offsetHeight===target.scrollHeight){
        const nextIndex = this.queryParam.current+1;
        this.setIndex(nextIndex);
        this.getStaffDropDownList(this.queryParam)
      }
    },
    setIndex(index){
      this.queryParam.current = index;
    },
    getStaffDropDownList(params){
      this.$api.staff.pageDropDownBySupplierId(params).then(res => {
        if (res.code === 200 && res.success) {
          this.staffList = res.data.records;
        }
      });
    },
  },
  watch:{
    currentValue(val){
      this.text = val.label;
    }
  }
}
</script>

<style scoped>

</style>